import React, { useEffect, useState } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { motion } from 'framer-motion';
import { CSSTransition } from "react-transition-group";

const startButton = {
    animating: {
        scale: [1, 1.2, 1, 1.2, 1],

        transition: {
            duration: 1.25,
            ease: "easeInOut",
            times: [0, 0.2, 0.5, 0.8, 1],
            loop: Infinity,
            repeatDelay: 10
        }
    }
};
const textContainer = {
    hidden: { opacity: 0, },
    show: {
        opacity: 1,

        transition: {
            delayChildren: 0.5,
            staggerChildren: 0.25,
            staggerDirection: -1,
        }
    }
};
const text = {
    hidden: {
        opacity: 0,
        y: -25,
    },
    show: {
        opacity: [0, 1, 1, 0],
        y: [-25, 0, 0, 50],

        transition: {
            duration: 15,
            times: [0, 0.05, 0.95, 1],
            loop: Infinity,
            repeatDelay: 1.5,
        }
    }
};

const LandingScreen = ({ config, gameData, passRefUpward }) => {
    const [displayComponent, setDisplayComponent] = useState(true);
    const [showRedirect, setShowRedirect] = useState(false);
    const [calibrationRedirect, setCalibrationRedirect] = useState(false);

    useEffect(() => {
        passRefUpward(false, false);
        exportSessionData();

        // add arrow key event listeners for team snake + fix-the-machine
        if (config.game === 'teamSnake') {
            window.addEventListener('keydown', checkKey)
        }

        if (config.game === 'fixTheMachine') {
            // hide webcam
            const webcamOverlay = document.querySelector('.webcam-overlay');
            webcamOverlay.classList.add('hide');

            window.addEventListener('start-button-press', startButtonPress)

            if (window.ipc) {
                window.ipc.removeAllListeners('phidget-ready');

                window.ipc.on('phidget-ready', () => {
                    window.ipc.invoke('reset-outputs');
                })
            }

            // Go to calibration on certain key press
            window.addEventListener('keydown', (e) => {
                if (e.code === 'KeyC' && e.altKey) {
                    setCalibrationRedirect(true);
                }
            })
        }

        return () => {
            window.removeEventListener('keydown', checkKey);
            window.removeEventListener('keydown', startButtonPress);
            window.removeEventListener('start-button-press', startButtonPress);
        }
        // eslint-disable-next-line
    }, []);

    const checkKey = (e) => {
        switch(e.key) {
            case 'ArrowLeft':
            case 'ArrowRight':
            case 'ArrowUp':
            case 'ArrowDown':
                startGame();
                setShowRedirect(true);
                break;
            default:
                break;
        }
    };

    const startButtonPress = (e) => {
        if (e.type === 'start-button-press' || e.code === 'Space') {
            setShowRedirect(true);
        }
    }

    const startGame = () => {
        setDisplayComponent(false);

        const sessionData = JSON.parse(window.sessionStorage.getItem('sessionData'));
        sessionData.startTime = Date.now();
        window.sessionStorage.setItem('sessionData', JSON.stringify(sessionData));
    };

    // const findSessionLength = (start, finish) => {
    //     let difference = finish - start;
    //     const minuteDiff = Math.floor(difference / 1000 / 60);
    //     difference -= minuteDiff * 1000 * 60;

    //     const secondDiff = Math.floor(difference / 1000);

    //     return `${minuteDiff} minute(s) ${secondDiff} seconds`;
    // }

    const exportSessionData = () => {
        const sessionData = JSON.parse(window.sessionStorage.getItem('sessionData'));

        if (sessionData && sessionData.startTime !== null && window.ipc) {
            const json = {};
            const duration = Date.now() - sessionData.startTime;
            const minutes = Math.floor(duration / 60000);
            const seconds = ((duration % 60000) / 1000).toFixed(0);
            json.duration = Number(seconds) === 60 ? (minutes+1) + ":00" : minutes + ":" + (seconds < 10 ? "0" : "") + seconds;

            json.playCount = sessionData.playData.length;

            json.playData = sessionData.playData;

            window.ipc.sendSync('session-data-send', json);
        }

        window.sessionStorage.setItem('sessionData', JSON.stringify({
            startTime: null,
            playData: []
        }))
    };

    return (
        <CSSTransition in={displayComponent} classNames="landingScreen" timeout={500} unmountOnExit>
            <div className={`landingScreen ${gameData.gameClass}`}>
                {showRedirect && <Redirect push to="/introduction" /> }

                {calibrationRedirect && <Redirect push to="/calibration" /> }

                {config.screens.landingScreen.video_path && (
                    <video
                        src={`img/game_icons/background_videos/${config.screens.landingScreen.video_path}`}
                        autoPlay
                        muted
                        loop
                        className="landingScreen__backgroundVideo"
                    />
                )}

                {config.game === 'fixTheMachine' &&
                    <div className="video-overlay"></div>
                }

                {gameData.gameClass === 'track-the-ball' && (
                    <div className ="bouncing-ball">
                        <div className="x">
                            <img className="y" src="img/game_icons/track-the-ball/ball-red.svg" alt=""/>
                        </div>
                    </div>
                )}

                {config.game === 'teamSnake' && (
                    <img className="team-snake-landingscreen-image" src='img/game_icons/snake/team-snake.png' alt=''/>
                )}

                <img src={`img/game_icons/squiggle-${gameData.screens.landingScreen.squiggle_colour}.png`} alt='' className={`landingScreen__squiggle squiggle-${gameData.screens.landingScreen.squiggle_colour}`}/>

                <div className='landingScreen__game App__game'>
                    <img src={`img/game_icons/${gameData.screens.landingScreen.icon}.svg`} alt='' />
                    <p>{config.screens.landingScreen.vertical_title || config.gameName }</p>
                </div>

                <motion.div className='landingScreen__text' variants={textContainer} initial="hidden" animate="show">
                    <motion.p variants={text} className='landingScreen__text-medium'>
                        {config.screens.landingScreen.medium_text}
                    </motion.p>
                    <motion.p variants={text} className='landingScreen__text-large'>
                        {config.screens.landingScreen.large_text}
                    </motion.p>
                </motion.div>

                <div className='landingScreen__buttons'>
                    {gameData.screens.landingScreen.display_leaderboard_button && (
                        <button className='landingScreen__buttons-leaderboard'>
                            <Link to="/leaderboard">{config.screens.landingScreen.leaderboard_link_text}</Link>
                        </button>
                    )}

                    {gameData.screens.landingScreen.display_start_button && (
                        <div className='App__button-large-container'>
                            <motion.button variants={startButton} animate='animating'>
                                <Link to={gameData.screens.landingScreen.start_link_path} onClick={startGame}>{config.screens.landingScreen.start_link_text}</Link>
                            </motion.button>
                            <span> </span> {/* Decorative span */}
                            <span> </span> {/* Decorative span */}
                        </div>
                    )}
                </div>

                {config.game === 'fixTheMachine' && (
                    <div className="start-text">
                        <p>{config.screens.landingScreen.start_text}</p>
                    </div>
                )}

                {config.game === 'teamSnake' && (
                    <div className="start-button">
                        <div className="text">
                            {config.screens.landingScreen.start_link_text}
                        </div>

                        <div className="arrows">
                            <img src="./img/game_icons/snake/arrow-outline.svg" className="left" alt='' />
                            <img src="./img/game_icons/snake/arrow-outline.svg" className="down" alt='' />
                            <img src="./img/game_icons/snake/arrow-outline.svg" className="up" alt='' />
                            <img src="./img/game_icons/snake/arrow-outline.svg" className="right" alt='' />
                        </div>
                    </div>
                )}
            </div>
        </CSSTransition>
    );
};

export default LandingScreen;
